import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { withSuspense } from '@festina-life/ui/libs'
import { SimpleModal } from '@festina-life/ui/structure'
import { useId, useState } from 'react'

import { AddBalancePostingForm } from './AddBalancePostingForm'
import type { SingletonBalancePostingPair } from './types'

type Props = {
  onSubmit: (values: SingletonBalancePostingPair) => void
}

const AddBalancePostingCommandInternal = ({ onSubmit }: Props) => {
  const translate = useTranslate()

  const formId = useId()
  const [isOpen, setIsOpen] = useState(false)

  const handleSubmit = (values: SingletonBalancePostingPair) => {
    onSubmit(values)
    setIsOpen(false)
  }

  return (
    <>
      <SimpleModal
        isOpen={isOpen}
        title={translate('collectivePots.action.addBalancePosting')}
        closeConfiguration={{ onClose: () => setIsOpen(false) }}
        acceptConfiguration={{ formId }}
      >
        <AddBalancePostingForm
          onSubmit={handleSubmit}
          formId={formId}
          initialValues={{
            sender: { _type: 'SingletonBalancePosting' },
            receiver: { _type: 'SingletonBalancePosting' },
          }}
        />
      </SimpleModal>
      <Button onClick={() => setIsOpen(true)}>
        {translate('collectivePots.action.addBalancePosting')}
      </Button>
    </>
  )
}

export const AddBalancePostingCommand = withSuspense(
  AddBalancePostingCommandInternal,
)
